import * as T from 'prop-types';
import { Field } from 'react-final-form';

import { Box } from '@olist/united';

const Condition = ({ children, is, when }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => <Box display={value === is ? 'block' : 'none'}>{children}</Box>}
  </Field>
);

Condition.propTypes = {
  children: T.node.isRequired,
  is: T.string.isRequired,
  when: T.string.isRequired,
};

export default Condition;
